import "react-multi-carousel/lib/styles.css";
import './css/Carousel.css';

const videoHeight = 450;
const baseVideoURL = "https://www.youtube.com/embed/";

function HomeCarouselItem({videoUrl, description}){
    const finalVideoURL = baseVideoURL+videoUrl;
    console.log(videoUrl);
    return (
        <div className="carousel-item">
            <iframe
                src={finalVideoURL}
                frameBorder='0'
                allow='autoplay; encrypted-media'
                allowFullScreen
                title='video'
                height={videoHeight}
                width='100%'
            />
            <br /><br />
            <div className="carousel-desc">
                <p>
                {description}
                </p>
            </div>
        </div>
    )
}

export default HomeCarouselItem;
